var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{attrs:{"content":_vm.localContent},on:{"ready":_vm.onEditorReady,"change":function($event){return _vm.onEditorChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }